import defaultState from './defaultState'
import { ResourceServiceType as actionTypes } from '../../../actions/src/resourceService/resourceServiceTypes'

const resourcesReducer = (state = { ...defaultState }, { type, payload }) => {

  switch (type) {
    case actionTypes.SET_VIEW:
      return {
        ...state,
        activeResource: '',
        view: payload,
        status: {
          isLoading: false,
          isSubmitting: false,
          isUploading: false,
          isProcessing: false,
          hasError: false,
          submitSuccess: false
        }
      }
    case actionTypes.FETCH_RESOURCES:
      return {
        ...state,
        activeResource: '',
        view: 'lists',
        status: {
          ...state.status,
          isLoading: true,
          isEdit: false
        },
        [payload.communicationId]: {
          data: state[payload.communicationId] ? state[payload.communicationId].data : null,
          dataLoading: true
        }
      }
    case actionTypes.FETCH_RESOURCES_SUCCESS:
      return {
        ...state,
        activeResource: '',
        view: 'lists',
        status: {
          ...state.status,
          isLoading: false,
          isEdit: false
        },
        [payload.communicationId]: {
          data: payload.data,
          dataLoading: false
        }
      }
    case actionTypes.FETCH_RESOURCES_FAILED:
      return {
        ...state,
        activeResource: '',
        view: 'lists',
        status: {
          ...state.status,
          isLoading: false,
          isEdit: false
        },
        [payload.communicationId]: {
          data: null,
          dataLoading: false
        }
      }
    case actionTypes.SUBMITING_ATTACHMENT:
      return {
        ...state,
        status: {
          ...state.status,
          isSubmitting: true
        }
      }
    case actionTypes.SUBMIT_ATTACHMENT_ERROR:
      return {
        ...state,
        view: 'lists',
        activeResource: payload.data,
        status: {
          ...state.status,
          isSubmitting: false,
          isProcessing: true,
          hasError: true
        },
        errors: payload
      }
    case actionTypes.ATTACHMENT_PROCESSING_FAILED:
      return {
        ...state,
        view: 'lists',
        status: {
          ...state.status,
          isSubmitting: false,
          isProcessing: true,
          hasError: true
        },
        errors: payload.error
      }
    case actionTypes.SUBMIT_ATTACHMENT_SUCCESS:
      return {
        ...state,
        activeResource: payload,
        status: {
          ...state.status,
          isSubmitting: false,
          submitSuccess: true
        }
      }
    case actionTypes.SELECT_ATTACHMENT_UPLOAD:
      return {
        ...state,        
        status: {
          ...state.status,
          isUploading: true
        }
      }
    case actionTypes.ATTACHMENT_UPLOADING_STATE:
      return {
        ...state,
        activeResource: {
          ...state.activeResource,
          ...payload.file,
          transferRate: payload.bytePerSec
        },
        status: {
          ...state.status,
          isUploading: true,
        }
      }
    case actionTypes.ATTACHMENT_PROCESSING_STATE:
    case actionTypes.ATTACHMENT_UPLOAD_SUCCESS:
      return {
        ...state,
        view: 'lists',
        status: {
          ...state.status,
          isUploading: false,
          isProcessing: true,
          isLoading: false
        }
      }
    case actionTypes.ATTACHMENT_UPLOAD_FAILED:
    case actionTypes.ATTACHMENT_NOT_FOUND:
      return {
        ...state,
        view: 'lists',
        status: {
          ...state.status,
          isUploading: false,
          isProcessing: true,
          hasError: true
        }
      }
    case actionTypes.ATTACHMENT_PROCESS_SUCCESS:
      return {
        ...state,
        view: 'lists',
        activeResource: '',
        status: {
          ...state.status,
          isUploading: false,
          isProcessing: false,
          isLoading: false
        }
      }
    case actionTypes.SELECT_ATTACHMENT:
      return {
        ...state,
        activeResource: payload,
        status: {
          ...state.status,
          isEdit: true
        }
      }
    case actionTypes.DELETE_RESOURCE:
      return {
        ...state,
        status: {
          ...state.status,
          isDeleting: true
        }
      }
    case actionTypes.DELETE_RESOURCE_SUCCESS:
      return {
        ...state,
        view: 'lists',
        activeResource: '',
        status: {
          ...state.status,
          isDeleting: false
        }
      }
    case actionTypes.DELETE_RESOURCE_FAILED:
      return {
        ...state,
        view: 'lists',
        activeResource: '',
        status: {
          ...state.status,
          isDeleting: false
        }
      }
    case actionTypes.REARRANGE_RESOURCE:
      return {
        ...state,
        status: {
          ...state.status
        }
      }
    case actionTypes.REARRANGE_RESOURCE_SUCCESS:
      return {
        ...state,
        [payload.communicationId]: {
          data: payload.data,
          dataLoading: false
        }
      }
    case actionTypes.REARRANGE_RESOURCE_FAILED:
      return {
        ...state,
        status: {
          ...state.status
        }
      }
    case actionTypes.FETCH_RESOURCE_SETTING:
      return {
        ...state
      }
    case actionTypes.FETCH_RESOURCE_SETTING_SUCCESS:
      return {
        ...state,
        setting: payload
      }
    case actionTypes.FETCH_RESOURCE_SETTING_FAILED:
      return {
        ...state,
        status: {
          ...state.status,
          hasError: true
        }
      }
    case actionTypes.CANCEL_ATTACHMENT_UPLOAD:
      return {
        ...state,
        activeResource: '',
        status: {
          ...state.status
        }
      }
    case actionTypes.GOTO_LISTING_PAGE:
      return {
        ...state,
        activeResource: '',
        status: {
          isLoading: false,
          isSubmitting: false,
          isUploading: false,
          isProcessing: false,
          hasError: false,
          submitSuccess: false
        }
      }
    case actionTypes.ADD_UPLOADER:
      return {
        ...state,
        uploader: payload
      }
    case actionTypes.SAVE_STATUS_INTERVAL:
      return {
        ...state,
        interval: [...(state.interval ? state.interval : []), payload]
      }
    case actionTypes.SET_VIEW_ONLY:
      return {
        ...state,
        view: payload
      }
    case actionTypes.UPDATE_CANCELLED_STATE:
      return {
        ...state,
        [payload.webcastId]: payload.resources,
        status: {
          ...state.status
        }
      }
    default:
      return state

  }

}

export default resourcesReducer
